// Central site configuration for Mitaja Corporation.
// Single source of truth for canonical URLs and company facts
// used by SEO metadata and JSON-LD structured data.

export const SITE_URL = "https://www.mitajacorp.com";

export const SITE_NAME = "Mitaja Corporation";

export const COMPANY = {
  legalName: "Mitaja Corporation",
  legalNameEn: "Mitaja Corporation",
  description:
    "Mitaja Corporation is a small, for-profit technology services and engineering company based in Fulton, Maryland, providing enterprise IT engineering, database and platform services, application support, and specialist technical delivery teams for government and commercial organizations.",
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.svg`,
  address: {
    streetAddress: "8115 Maple Lawn Blvd., Suite 350",
    addressLocality: "Fulton",
    addressRegion: "MD",
    postalCode: "20759-2683",
    addressCountry: "US",
  },
  telephone: null as string | null,
  email: "governmentsales@mitajacorp.com",
  uei: "C9PPAQCM5DD9",
  cage: "7PBY4",
  gsaMas: "47QTCA22D0083",
  foundinYear: null as number | null,
} as const;

export const KEYWORDS = [
  "government IT services",
  "government technology services",
  "IT professional services",
  "IT staff augmentation",
  "application development",
  "application maintenance and support",
  "software development services",
  "systems integration",
  "database services",
  "web application development",
  "website development",
  "CMS development",
  "IT engineering services",
  "federal government IT contractor",
  "state and local government IT services",
];